import { Avatar, Box, Divider } from '@mui/material';
import React, { useState, useEffect } from 'react';
import ArrowSquareLeft from '../../assets/NavbarIcon/sidebar-open-close-icon.svg';
import { useOpen } from '../../context/OpenContext';
import './TeacherNavbar.css';
import { useAuth } from '../../context/AuthContext';
import Notification from '../Notification/Notification';
import { getCacheBustedImageUrl } from '../../utils/profileImageUtils';

const TeacherNavbar = () => {
  const [auth] = useAuth();
  const [open, setOpen] = useOpen();
  const [profileImageUrl, setProfileImageUrl] = useState('');

  // Update profile image URL with cache busting when profile image changes
  useEffect(() => {
    if (auth?.profile_image) {
      setProfileImageUrl(getCacheBustedImageUrl(auth.profile_image));
    } else {
      setProfileImageUrl('');
    }
  }, [auth?.profile_image]);

  const toggleUserExpanded = () => {
    setOpen(!open);
  };

  return (
    <Box
      className="flex justify-between items-center pt-3 pb-4 pr-2 h-[8vh]"
      data-testid="admin-navbar"
    >
      <img
        src={ArrowSquareLeft}
        alt="arrow-square-left"
        style={{ cursor: 'pointer' }}
        onClick={toggleUserExpanded}
        data-testid="toggle-button"
      />
      <Box className="flex items-center gap-3 h-[80%]" data-testid="profile-container">
        <Notification data-testid="notification-component" />

        <Divider orientation="vertical" flexItem />
        <Box className="flex items-center gap-2" data-testid="profile-section">
          <Avatar
            data-testid="admin-avatar"
            src={profileImageUrl}
            alt={`${auth?.first_name} ${auth?.last_name}`}
            onError={() => setProfileImageUrl('')}
            sx={{
              width: '32px',
              height: '32px',
              backgroundColor: profileImageUrl ? 'transparent' : '#0A5EF3',
              color: profileImageUrl ? 'transparent' : '#FFFFFF',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            {!profileImageUrl &&
              `${auth?.first_name?.charAt(0) || ''}${auth?.last_name?.charAt(0) || ''}`}
          </Avatar>
          <Box className="flex flex-col gap-1 h-[32px]">
            <Box className="admin-name">
              {auth?.first_name} {auth?.last_name}
            </Box>
            <Box className="admin-email">{auth?.user_type === 'teacher' ? 'Instructor' : ''}</Box>
          </Box>
          {/* <Box onClick={handleProfileClick} sx={{ cursor: 'pointer' }}>
            {menuOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </Box>
          <Menu anchorEl={anchorEl} open={menuOpen} onClose={handleClose}>
            <MenuItem onClick={handleLogout}>Logout</MenuItem>
          </Menu> */}
        </Box>
      </Box>
    </Box>
  );
};

export default TeacherNavbar;
